import { render, staticRenderFns } from "./PointConfiguration.vue?vue&type=template&id=6e768cbb&scoped=true&"
import script from "./PointConfiguration.vue?vue&type=script&lang=js&"
export * from "./PointConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./PointConfiguration.vue?vue&type=style&index=0&id=6e768cbb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e768cbb",
  null
  
)

export default component.exports